import { DatasetVersionCreateButton } from "@/components/DatasetVersionCreateButton";
import { List } from "@/components/DatasetVersionHistory/List";
import { XIcon } from "@/icons";
import { Button } from "@/kit/ui/button";
import {
  ResponsiveModalClose,
  ResponsiveModalFooter,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
} from "@/kit/ui/responsive-modal";
import {
  ResponsiveSheet,
  ResponsiveSheetContent,
  ResponsiveSheetPortal,
  ResponsiveSheetProps,
} from "@/kit/ui/responsive-sheet";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { DatasetVersionsHelmet } from "../DatasetVersionsHelmet";
import { DatasetVersionHistoryFragment$key } from "./__generated__/DatasetVersionHistoryFragment.graphql";

const DatasetVersionHistoryFragment = graphql`
  fragment DatasetVersionHistoryFragment on Dataset {
    slug
    name
    ...ListVersionHistoryFragment
    ...DatasetVersionsHelmetFragment
    ...DatasetVersionCreateButtonFragment
    viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)
  }
`;

type Props = ResponsiveSheetProps & {
  dataset: DatasetVersionHistoryFragment$key;
};

export function Sheet({
  dataset: datasetFragement,
  ...props
}: Readonly<Props>) {
  const dataset = useFragment(DatasetVersionHistoryFragment, datasetFragement);

  return (
    <ResponsiveSheet {...props}>
      <DatasetVersionsHelmet dataset={dataset}>
        <ResponsiveSheetPortal>
          <ResponsiveSheetContent>
            <ResponsiveModalHeader className="flex flex-col justify-between items-center sm:p-6  px-4 pt-4 pb-5 border-b border-t-grey-200">
              <div className="w-full flex flex-row items-center justify-between">
                <ResponsiveModalTitle>
                  <p className="text-xl font-semibold text-grey-900">
                    <FormattedMessage defaultMessage="Version history" />
                  </p>
                </ResponsiveModalTitle>
                <ResponsiveModalClose
                  className="sm:flex hidden items-center"
                  asChild
                >
                  <Button variant="tertiary" size="md" hue="grey" icon>
                    <XIcon className="w-5 h-5" />
                  </Button>
                </ResponsiveModalClose>
              </div>
            </ResponsiveModalHeader>
            <div className="flex flex-col items-start gap-4 px-6 pt-4 pb-6 overflow-y-auto">
              <List dataset={dataset} />
            </div>
            {dataset.viewerCanCreateDatasetVersion && (
              <ResponsiveModalFooter className="flex flex-col justify-center items-end sm:p-6 px-4 pt-4 pb-8 border-t border-t-grey-200">
                <DatasetVersionCreateButton dataset={dataset} />
              </ResponsiveModalFooter>
            )}
          </ResponsiveSheetContent>
        </ResponsiveSheetPortal>
      </DatasetVersionsHelmet>
    </ResponsiveSheet>
  );
}
